import "./HeaderHero.scss";
import { Link } from "react-router-dom";
import bmwLogoWhite from "../../assets/bmwLogo_white.webp";

const HeaderHero = ({
  title = "CHOOSE YOUR PACKAGE",
  subtitle = "Select your desired agency and package.",
  disclaimer = "",
  alwaysOnPackageError = true
}) => {
  return (
    <div className="form-hero-container">
      <div className="logo-container-wrapper">
        <div className="logo-container">
          <Link to="/" className="logo-text">
            <p>BMW EASTERN REGION</p>
            <p>DIGITAL PROGRAMS 2026</p>
          </Link>
          <img src={bmwLogoWhite} alt="BMW Logo" className="bmw-logo" />
        </div>
      </div>
      <div className="header-hero-content">
        <h1>{title}</h1>
        <p>{subtitle}</p>
        {/* {disclaimer && (
          <div className="header-hero-disclaimer">
            <p>{disclaimer}</p>
          </div>
        )} */}
        
      </div>
    </div>
  );
};

export default HeaderHero;
